import Actions from 'actions';

const initialState = Object.freeze([]);

function addedList(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_ADDED_EVENTS_SUCCESS:
      return action.data;
    case Actions.SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}

export default addedList;
